//引入安装的signalr包
import * as signalR from '@aspnet/signalr'

const signal = new signalR.HubConnectionBuilder()
//服务器地址
    .withUrl('http://47.105.165.74:8055/actionHubs', {})
    .build()

const signalGraf = new signalR.HubConnectionBuilder()
//服务器地址
    .withUrl('http://47.105.165.74:8055/grafHubs', {})
    .build();


// const signalr = function () {
//     var hub
//     if (hub === undefined) {
//         hub = signal
//     }
//     return hub
// }
//  自动重连
 async function start () {
  try {
      await  location.reload()
  } catch (err) {
    setTimeout(() => start(), 5000)
  }
}

signal.onclose(async () => {
  await start()
})
//将创建的signal赋值给Vue实例
export default {
    install: function(Vue) {
        Vue.prototype.signalr = signal;
        Vue.prototype.signalGraf = signalGraf;
    }
}
